import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const RefreshIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M7.146.146a.5.5 0 0 1 .708 0l2.994 2.995.006.005a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.707-.708L9.293 4h-1.29C5.25 4.015 3 6.251 3 9a5 5 0 0 0 10 0 .5.5 0 0 1 1 0A6 6 0 0 1 2 9c0-3.306 2.702-5.982 5.997-6h1.296L7.146.854a.5.5 0 0 1 0-.708Z" />
  </IconWrapper>
)

export default RefreshIconSmall
